export default "__VITE_ASSET__BCgYodWs__"